import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { ProductSegmentService } from '../product-segment.service';
import { ProductsService } from '../../products/products.service';

@Component({
  selector: 'itpx-product-segment-edit',
  templateUrl: './product-segment-edit.component.html',
  styleUrls: ['./product-segment-edit.component.css']
})
export class ProductSegmentEditComponent implements OnInit {

    private details: any;
    private cancelRoute: string = '/agora/product-data/product-segments';
    private fields: any[];
    private id: string;

    constructor(
            private service: ProductSegmentService,
            private configService: ConfigService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute
    ) { }

    ngOnInit() {

            this.route.params.subscribe(params => {
                this.id = params['id'];
                this.fields = this.service.getFields();
                this.service.getProductSegmentDetails(this.id)
                    .subscribe(
                        body => {
                            this.setDetails(<any>body['data']);
                        }
                    );
            });
    }

    private setDetails(details: any) {
        details.customerSegments = details.customerSegments ? details.customerSegments.map(_ => { return _.id }) : [];
        this.details = details;
    }

    private onSaveFinished(data: any) {
        this.service.edit(this.service.formatData(data))
        .subscribe(
            body => {
                const response = body['data'];
                this.notificationService.success('Successfully updated the product segment', 'Success');
                this.router.navigate(['/agora/product-data/product-segments/:id/details', { id: this.id }]);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-segments/edit/product-segment-edit.component.ts